import router from '@/router'
import { Message, MessageBox } from 'element-ui'
// 进度条
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import utils from '@/utils/util'

// import { getToken } from '@/utils/auth.js'
router.beforeEach((to, from, next) => {
    //处理登录过期时间
    // let status = utils.timeLogout("firstTime","userInfo",1000*60*15)
    NProgress.start()
    const user = localStorage.getItem('userInfo');
    console.log('user:',user)
    // to.meta.title
    // window.document.title = to.meta.title === undefined ? '状态异常' : `${to.meta.title}-甘肃文旅大数据`
    if (!user && to.path !== '/'){
        if(status === 1){
            Message({
                message: '您还未登录',
                type: 'warning'
            })
        }else{
            Message({
                message: '长时间未操作，退出登录',
                type: 'warning'
            })
        }
        next('/')
        NProgress.done()
    }else{
        next()
    }


})
router.afterEach(to => {
    // 进度条
    NProgress.done()
    // 多页控制 打开新的页面
    // store.dispatch('d2admin/page/open', to)

    // util.setTitle(localStorage.getItem('uid'))
    // 更改标题
    // util.title(to.meta.title)
})



// WEBPACK FOOTER //
// ./src/router/routingGuard.js